import React from 'react';
import {Grid, Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function DetailPdf({item, id, setSelectedFile}) {
  const pdfAttachment = item?.attachments?.find(attachment => attachment.id === id);

  return (
    <div>
      <Tooltip title={'Close'}>
        <IconButton sx={{float: 'right'}}>
          <CloseRoundedIcon onClick={() => setSelectedFile(null)} fontSize={'large'} sx={{color: 'red'}}/>
        </IconButton>
      </Tooltip>
      <Grid container spacing={2}>
        <Grid item sm={1}/>
        {pdfAttachment && pdfAttachment.type === 'application/pdf' && (
          <Grid item sm={10}>
            <embed src={pdfAttachment.file} type="application/pdf" width="100%" height="800px"/>
          </Grid>)}
      </Grid>
    </div>
  );
}